import React from 'react';

import styled from '@emotion/styled';

import { Box, COLORS, Text } from '@clutter/clean';

import planSize from '@images/illustrations/plan_size_small.svg';

const Illustration = styled.img`
  height: 33px;
  margin-right: 16px;
  filter: grayscale(1);
`;

export const StorageCartValueProps: React.FC = () => (
  <Box.Flex gap="32px" justifyContent="center">
    <Box.Flex>
      <Illustration src={planSize} alt="" />
      <Text.Caption color={COLORS.storm}>
        We’ll lower your monthly rate if you need less space.
      </Text.Caption>
    </Box.Flex>
  </Box.Flex>
);
